import * as AuthApi from '@bmai/auth-api-client';
import { ApiClientFactory } from './ApiClientFactory';

const configuration = new AuthApi.Configuration(ApiClientFactory.createConfig('/_auth'));

export const authClient = {
    ...ApiClientFactory.instantiateApis(AuthApi, configuration),
    authSessionClient: new AuthApi.AuthSessionClient({ configuration }),
};
